import React, { useState } from 'react';

const CustomDatepicker = (props) => {
    const data = [
        { id: 1, name: "John Doe" },
        { id: 2, name: "Victor Wayne" },
        { id: 3, name: "Jane Doe" },
    ];
    return (
        <div className='custom_datepicker_section'>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>01</h6>
                    <p>Mon</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>02</h6>
                    <p>Tue</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>03</h6>
                    <p>Wed</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area active">
                <div className="content_area">
                    <h6>04</h6>
                    <p>Thu</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>05</h6>
                    <p>Fri</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>06</h6>
                    <p>Sat</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>07</h6>
                    <p>Sun</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>06</h6>
                    <p>Sat</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>07</h6>
                    <p>Sun</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>06</h6>
                    <p>Sat</p>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="inner_datepicker_area">
                <div className="content_area">
                    <h6>07</h6>
                    <p>Sun</p>
                    <div className="dot"></div>
                </div>
            </div>
        </div>
    );
}

export default CustomDatepicker;